const Categories = [
    { category: "General Knowledge",value: 9 },
    { category: "Entertainment: Books", value: 10 },
    { category: "Entertainment: Film", value: 11 },
    { category: "Entertainment: Music", value: 12 },
    { category: "Entertainment: Television", value: 14 },
    { category: "Entertainment: Video Games", value: 15 },
    { category: "Entertainment: Board Games", value: 16 },
    { category: "Entertainment: Comics", value: 29 },
    { category: "Entertainment: Cartoon and Animations", value: 32 },
    { category: "Entertainment: Japanese Anime", value: 31 },
    { category: "Science & Nature", value: 17 },
    { category: "Science: Computers", value: 18 },
    { category: "Mythology", value: 20 },
    { category: "Sports", value: 21 },
    { category: "Geography", value: 22 },
    { category: "History", value: 23 },
    { category: "Celebrities", value: 26 },
    { category: "Animals", value: 27 },
    { category: "Vehicles", value: 28 }
    
  ];
  
  export default Categories;